import styled from "styled-components";

const Spacer = styled.div`
  ${props => (props.horizontal ? `height: ${props.horizontal}px` : "")}
  ${props => (props.vertical ? `width: ${props.vertical}px` : "")}
`;

export default Spacer;
